<template>
  <b-tabs
    content-class="pt-1"
    fill
  >
    <b-tab
      activen
      lazy
    >
      <template #title>
        <feather-icon icon="ShoppingCartIcon" />
        <span>Solicitudes</span>
      </template>
      <KeepAlive>
        <solicitudes />
      </KeepAlive>
    </b-tab>
    <b-tab lazy>
      <template #title>
        <feather-icon icon="BellIcon" />
        <span>Plan Pagos</span>
      </template>
      <plan-pagos />
    </b-tab>
    <b-tab lazy>
      <template #title>
        <feather-icon icon="DollarSignIcon" />
        <span>Aportaciones</span>
      </template>
      <aportaciones :is-lista="true" />
    </b-tab>
    <b-tab>
      <template #title>
        <feather-icon icon="SearchIcon" />
        <span>Busqueda</span>
      </template>
      <KeepAlive>
        <resumen-user />
      </KeepAlive>
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import ResumenUser from '@/views/campus/usuarios/Resumen/Inicio.vue'
import Solicitudes from './compras-list/SolicitudesSE.vue'
import PlanPagos from './compras-list/PlanPagos.vue'
import Aportaciones from './compras-list/TransList.vue'

export default {
  components: {
    BTabs,
    BTab,
    // BCardText,
    Solicitudes,
    PlanPagos,
    Aportaciones,
    ResumenUser,
  },
}
</script>
